<script lang="ts">
  import type { AttributeOptions } from '../modules/attributes';
  import type { BuildEnv } from '../modules/attributes';

  type Props = {
    attributes: AttributeOptions;
    build: BuildEnv;
  };
  const { attributes, build }: Props = $props();

  const LOADER_ID = 'resi-loader-script';
  function videoRoot() {
    if (build === 'dev') {
      return 'build/loader.min.js';
    }

    if (build === 'prod') {
      return 'https://control.resi.io/webplayer/loader.min.js';
    }

    return 'https://control.resi.io/webplayer/loader-test.min.js';
  }

  const initScript = (_node: Node) => {
    if (document.getElementById(LOADER_ID) === null) {
      let script = document.createElement('script');
      script.setAttribute('src', videoRoot());
      script.setAttribute('id', LOADER_ID);
      script.setAttribute('type', 'application/javascript');
      document.body.appendChild(script);
    }

    return {
      destroy() {
        /*
         * This should only run when both the loader script and bundle script are present
         * Hence the logic below will run once 2+ scripts are present.
         */
        const scripts = document.body.getElementsByTagName('script');
        let i = scripts.length - 1;
        while (i--) {
          document.body.removeChild(scripts[i] as HTMLScriptElement);
        }
      },
    };
  };
</script>

<div
  use:initScript
  id="resi-video-player"
  data-autoplay={attributes.autoplay}
  data-background={attributes.background}
  data-bitrate-limit={attributes.bitrateLimitEnabled}
  data-chunked-transfer={attributes.chunkedTransfer}
  data-controls={attributes.controls}
  data-call-to-action-button={attributes.callToActionButton}
  data-debug={attributes.debug}
  data-embed-id={attributes.id}
  data-env={attributes.env}
  data-iframe-id={attributes.iframeId}
  data-is-ios={attributes.isIos}
  data-loop={attributes.loop}
  data-manifest={attributes.manifest}
  data-encoded-manifest={attributes.encodedManifest}
  data-scrub-bar={attributes.scrubBar}
  data-start-pos={attributes.startPos}
  data-studio={attributes.studio}
  data-type={attributes.type}
  data-version={attributes.version}
  data-mute={attributes.mute} />

<style>
</style>
